import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import photo from "./Components/assets/salesforce.png";
class Thanks extends Component {
  state = {
    thanks: true,
  };
  componentWillMount() {
    this.props.thanksRecieved(this.state.thanks);
  }
  render() {
    return (
      <div style={{ alignItems: "center" }}>
        <center>
          <img src={photo} style={{ width: "140px", height: "100px" }} />
          <h1>Thanks for connecting with Salesforce</h1>
          <h2>Click on logout to exit</h2>
          <Button
            style={{
              background: "#0456d9",
              fontFamily: "inherit",
              fontSize: "12px",
              color: "white",
            }}
            onClick={() =>
              (window.location =
                "https://ap17.lightning.force.com/secur/logout.jsp")
            }
          >
            {" "}
            LogOut
          </Button>
        </center>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    thanks: state.thanks,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    thanksRecieved: (data) =>
      dispatch({
        type: "Thanks",
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Thanks);
